/* WarGrounds — JS minimal (menu mobile, quantités, galerie, tri) */
document.addEventListener('DOMContentLoaded', function () {
  // Menu mobile
  var burger = document.querySelector('[data-wg-burger]');
  var mobileNav = document.querySelector('[data-wg-mobile-nav]');
  if (burger && mobileNav) {
    burger.addEventListener('click', function () {
      var open = mobileNav.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // Sélecteurs de quantité (+ / −)
  document.querySelectorAll('[data-wg-qty]').forEach(function (box) {
    var input = box.querySelector('input');
    box.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = btn.dataset.dir === 'up' ? 1 : -1;
        var v = Math.max(parseInt(input.min || '1', 10), (parseInt(input.value, 10) || 1) + step);
        input.value = v;
        // Sur la page panier : soumettre la mise à jour
        var form = input.closest('form[action="/cart"]');
        if (form && input.dataset.autoSubmit === 'true') form.submit();
      });
    });
  });

  // Galerie produit
  var mainImg = document.querySelector('[data-wg-main-image]');
  document.querySelectorAll('[data-wg-thumb]').forEach(function (t) {
    t.addEventListener('click', function () {
      if (!mainImg) return;
      mainImg.src = t.dataset.src;
      mainImg.dataset.zoomSrc = t.dataset.src;
      mainImg.srcset = '';
      document.querySelectorAll('[data-wg-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
      t.classList.add('is-active');
    });
  });

  // Sélecteur de taille (fiche produit) : navigation vers le produit choisi
  var sizeSelect = document.querySelector('[data-wg-size-select]');
  if (sizeSelect) {
    sizeSelect.addEventListener('change', function () {
      if (sizeSelect.value) window.location.href = sizeSelect.value;
    });
  }

  // Tri collection
  var sort = document.querySelector('[data-wg-sort]');
  if (sort) {
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      if (sort.value) { url.searchParams.set('sort_by', sort.value); }
      else { url.searchParams.delete('sort_by'); }
      window.location.href = url.toString();
    });
  }

  /* ── Ajout panier AJAX + toast (CRO : rester dans le flux d'achat) ── */
  function euros(cents) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }

  /* ── Jauge livraison offerte (fiche produit) — état réel du panier ── */
  var gauge = document.querySelector('[data-wg-shipgauge]');
  function updateGauge(cart) {
    if (!gauge) return Promise.resolve();
    var render = function (c) {
      var badge = document.querySelector('[data-wg-cart-count]');
      var threshold = parseInt((badge && badge.dataset.freeShipping) || '8000', 10);
      var text = gauge.querySelector('[data-wg-shipgauge-text]');
      var fill = gauge.querySelector('[data-wg-shipgauge-fill]');
      if (!c || c.item_count === 0) {
        text.innerHTML = 'Livraison offerte dès <b>' + euros(threshold) + '</b> · livrée en 3 à 5 jours ouvrés';
        fill.style.width = '0%';
      } else if (c.total_price >= threshold) {
        text.innerHTML = '<b>Livraison offerte</b> — votre panier (' + euros(c.total_price) + ') a atteint le seuil';
        fill.style.width = '100%';
      } else {
        text.innerHTML = 'Votre panier : ' + euros(c.total_price) + ' — plus que <b>' + euros(threshold - c.total_price) + '</b> pour la livraison offerte';
        fill.style.width = Math.min(100, Math.round(c.total_price * 100 / threshold)) + '%';
      }
      gauge.hidden = false;
    };
    if (cart) { render(cart); return Promise.resolve(); }
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(render).catch(function () {});
  }
  updateGauge();

  /* ── Fiche produit : CTA dynamique (quantité × prix) ── */
  var buyCta = document.querySelector('[data-wg-buy-cta]');
  var buyQty = document.querySelector('[data-wg-buy] input[name=quantity]');
  var stickyQty = document.querySelector('[data-wg-sticky-qty]');
  if (buyCta && buyQty && !buyCta.disabled) {
    var unit = parseInt(buyCta.dataset.unitPrice, 10);
    var updateCta = function () {
      var q = Math.max(1, parseInt(buyQty.value, 10) || 1);
      buyCta.textContent = (buyCta.dataset.label || 'Ajouter au panier') + ' — ' + euros(unit * q);
      if (stickyQty) stickyQty.value = q;
    };
    buyQty.addEventListener('change', updateCta);
    buyQty.addEventListener('input', updateCta);
    document.querySelectorAll('[data-wg-buy] [data-wg-qty] button').forEach(function (b) {
      b.addEventListener('click', function () { setTimeout(updateCta, 0); });
    });
  }

  /* ── Fiche produit : barre d'achat sticky quand le CTA principal sort de l'écran ── */
  var stickyBar = document.querySelector('[data-wg-sticky-buy]');
  var buyZone = document.querySelector('[data-wg-buy]');
  if (stickyBar && buyZone) {
    var stickyTick = false;
    var stickyCheck = function () {
      var r = buyZone.getBoundingClientRect();
      var show = r.bottom < 0; // le bloc d'achat est passé au-dessus de l'écran
      stickyBar.classList.toggle('is-visible', show);
      stickyBar.setAttribute('aria-hidden', show ? 'false' : 'true');
      stickyTick = false;
    };
    window.addEventListener('scroll', function () {
      if (!stickyTick) { stickyTick = true; requestAnimationFrame(stickyCheck); }
    }, { passive: true });
    stickyCheck();
  }

  /* ── Fiche produit : lightbox zoom ── */
  var zoomWrap = document.querySelector('[data-wg-zoom]');
  if (zoomWrap && zoomWrap.querySelector('img')) {
    var lb = document.createElement('div');
    lb.className = 'wg-lightbox';
    lb.innerHTML = '<button class="wg-lightbox__close" aria-label="Fermer">Fermer ✕</button><img alt="">';
    document.body.appendChild(lb);
    var lbImg = lb.querySelector('img');
    zoomWrap.addEventListener('click', function () {
      var main = zoomWrap.querySelector('img');
      lbImg.src = main.dataset.zoomSrc || main.src;
      lb.classList.add('is-open');
    });
    lb.addEventListener('click', function () { lb.classList.remove('is-open'); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') lb.classList.remove('is-open'); });
  }

  var toast;
  function showToast(title, cart) {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'wg-toast';
      document.body.appendChild(toast);
    }
    var badge = document.querySelector('[data-wg-cart-count]');
    if (badge) badge.textContent = cart.item_count;
    var threshold = parseInt((badge && badge.dataset.freeShipping) || '8000', 10);
    var remaining = threshold - cart.total_price;
    var shipLine = remaining > 0
      ? 'Plus que <b>' + euros(remaining) + '</b> pour la livraison offerte'
      : '<b>Livraison offerte</b> — seuil atteint';
    toast.innerHTML =
      '<div class="wg-toast__check">✓</div>' +
      '<div class="wg-toast__body"><b>' + title + '</b> ajouté au panier<br><span>' + shipLine + '</span></div>' +
      '<a href="/cart" class="wg-toast__cta">Voir le panier →</a>';
    toast.classList.add('is-visible');
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { toast.classList.remove('is-visible'); }, 5000);
  }

  document.querySelectorAll('form[action$="/cart/add"], form[action*="/cart/add?"]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[type=submit]');
      if (btn) { btn.disabled = true; }
      var fd = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function (item) {
          // « Souvent commandé avec » : ajouter aussi le compagnon coché
          var comp = form.closest('.wg-buybox') ? form.closest('.wg-buybox').querySelector('[data-wg-companion]') : null;
          var compAdd = (comp && comp.checked)
            ? fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: parseInt(comp.value, 10), quantity: 1 }) }).then(function () { comp.checked = false; }).catch(function () {})
            : Promise.resolve();
          return compAdd.then(function () {
            // Sur la page panier : recharger pour rafraîchir lignes et totaux
            if (window.location.pathname === '/cart') { window.location.reload(); return; }
            return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
              var title = (item.product_title || 'Article').split('—')[0].trim();
              if (comp && !comp.checked && comp.dataset.added !== 'false') { /* compagnon éventuellement ajouté */ }
              if (!wgOpenDrawer(cart)) showToast(title, cart);
              updateGauge(cart);
              updateAnnounce(cart);
            });
          });
        })
        .catch(function () { form.submit(); })
        .finally(function () { if (btn) { btn.disabled = false; } });
    });
  });

  /* ══ Personnalisation légère : préférences visiteur, UTM, panier, sans cookie tiers ══ */
  var WG_KEY = 'wg_pref';
  function wgPref() { try { return JSON.parse(localStorage.getItem(WG_KEY) || '{}'); } catch (e) { return {}; } }
  function wgSavePref(p) { try { localStorage.setItem(WG_KEY, JSON.stringify(p)); } catch (e) {} }

  /* Source de trafic : ?gamme=… ou UTM contenant un slug de gamme → préférence */
  var wgSlugs = ['drylands', 'fallen-empire', 'old-city', 'no-mans-land'];
  try {
    var qs = new URLSearchParams(window.location.search);
    var utmRaw = ((qs.get('gamme') || '') + ' ' + (qs.get('utm_content') || '') + ' ' + (qs.get('utm_campaign') || '')).toLowerCase();
    wgSlugs.forEach(function (s) {
      if (utmRaw.indexOf(s) !== -1) { var p0 = wgPref(); p0.gamme = s; wgSavePref(p0); }
    });
  } catch (e) {}

  /* Fiche produit : mémoriser la dernière position (gamme, taille, page) */
  var pmeta = document.querySelector('.wg-product[data-wg-gamme]');
  if (pmeta) {
    var pp = wgPref();
    if (pmeta.dataset.wgGamme) pp.gamme = pmeta.dataset.wgGamme;
    if (pmeta.dataset.wgSize) pp.size = pmeta.dataset.wgSize;
    pp.lastUrl = window.location.pathname;
    pp.lastTitle = (document.title || '').split('–')[0].split('—')[0].trim();
    wgSavePref(pp);
  }
  /* Page de gamme : mémoriser l'univers consulté */
  var pathBits = window.location.pathname.split('/');
  if (pathBits[1] === 'collections' && wgSlugs.indexOf(pathBits[2]) !== -1) {
    var pg = wgPref(); pg.gamme = pathBits[2]; wgSavePref(pg);
  }

  /* Home : best-sellers réordonnés sur la gamme préférée + barre « reprendre » */
  if (window.location.pathname === '/' || window.location.pathname === '') {
    var pref = wgPref();
    var bestGrid = document.querySelector('#bestsellers .wg-product-grid');
    if (bestGrid && pref.gamme) {
      var prefCards = Array.prototype.slice.call(bestGrid.querySelectorAll('.wg-card[data-gamme="' + pref.gamme + '"]'));
      prefCards.reverse().forEach(function (c) { bestGrid.insertBefore(c, bestGrid.firstElementChild); });
    }
    var bestWrap = document.querySelector('#bestsellers .wg-container');
    if (bestWrap && pref.lastUrl && pref.lastTitle) {
      var bar = document.createElement('a');
      bar.className = 'wg-resume';
      bar.href = pref.lastUrl;
      var k = document.createElement('span'); k.className = 'wg-resume__k'; k.textContent = '► Dernière position';
      var t = document.createElement('b'); t.textContent = pref.lastTitle;
      var c2 = document.createElement('span'); c2.className = 'wg-resume__cta'; c2.textContent = 'Reprendre →';
      bar.appendChild(k); bar.appendChild(t); bar.appendChild(c2);
      bestWrap.insertBefore(bar, bestWrap.firstElementChild);
    }
  }

  /* Bandeau d'annonce : bascule sur l'état réel du panier dès qu'il n'est pas vide */
  function updateAnnounce(cart) {
    var el = document.querySelector('[data-wg-announce-cart]');
    var def = document.querySelector('[data-wg-announce-default]');
    if (!el || !cart || cart.item_count === 0) return;
    var badge = document.querySelector('[data-wg-cart-count]');
    var threshold = parseInt((badge && badge.dataset.freeShipping) || '8000', 10);
    if (cart.total_price >= threshold) {
      el.textContent = '✓ Livraison offerte activée — votre panier a passé le seuil des ' + euros(threshold);
    } else {
      el.textContent = 'Plus que ' + euros(threshold - cart.total_price) + ' pour la livraison offerte — panier : ' + euros(cart.total_price);
    }
    el.hidden = false;
    if (def) def.hidden = true;
  }
  fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
    updateAnnounce(cart);
    var badge = document.querySelector('[data-wg-cart-count]');
    if (badge && cart) badge.textContent = cart.item_count;
  }).catch(function () {});

  /* ── Ambiance : kickers en machine à écrire à l'apparition ── */
  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var typeKicker = function (el) {
      if (el.dataset.typed) return;
      el.dataset.typed = '1';
      var txt = el.textContent;
      el.textContent = '';
      el.classList.add('is-typing');
      var i = 0;
      var t = setInterval(function () {
        i += 1;
        el.textContent = txt.slice(0, i);
        if (i >= txt.length) { clearInterval(t); el.classList.remove('is-typing'); }
      }, 16);
    };
    var kickers = document.querySelectorAll('.wg-kicker');
    if ('IntersectionObserver' in window) {
      var kio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { typeKicker(e.target); kio.unobserve(e.target); }
        });
      }, { threshold: 0.4 });
      kickers.forEach(function (k) { kio.observe(k); });
    }
  }

  /* ══ Drawer panier — ouvert après ajout, contenu depuis /cart.js ══ */
  var wgDrawer = document.querySelector('[data-wg-drawer]');

  function wgDrawerRefreshAll(cart) {
    var badge = document.querySelector('[data-wg-cart-count]');
    if (badge) {
      badge.textContent = cart.item_count;
      badge.classList.remove('is-burst');
      void badge.offsetWidth; /* redémarre l'animation */
      badge.classList.add('is-burst');
    }
    updateGauge(cart);
    updateAnnounce(cart);
  }

  function wgDrawerRender(cart) {
    var linesBox = wgDrawer.querySelector('[data-wg-drawer-lines]');
    var count = wgDrawer.querySelector('[data-wg-drawer-count]');
    var subtotal = wgDrawer.querySelector('[data-wg-drawer-subtotal]');
    count.textContent = '· ' + cart.item_count + ' article' + (cart.item_count > 1 ? 's' : '');
    subtotal.textContent = euros(cart.total_price);
    linesBox.innerHTML = '';

    cart.items.forEach(function (it) {
      var row = document.createElement('div');
      row.className = 'wg-drawer__line';

      var img = document.createElement('img');
      if (it.image) img.src = it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=120';
      img.alt = ''; img.width = 56; img.height = 56; img.loading = 'lazy';
      row.appendChild(img);

      var mid = document.createElement('div');
      var t = document.createElement('b');
      t.textContent = (it.product_title || '').split('—')[0].trim();
      var m = document.createElement('small');
      m.textContent = ((it.product_title || '').split('—')[1] || '').trim();
      var qty = document.createElement('div');
      qty.className = 'wg-drawer__qty';
      var minus = document.createElement('button'); minus.type = 'button'; minus.textContent = '−'; minus.setAttribute('aria-label', 'Réduire');
      var qv = document.createElement('span'); qv.textContent = it.quantity;
      var plus = document.createElement('button'); plus.type = 'button'; plus.textContent = '+'; plus.setAttribute('aria-label', 'Augmenter');
      qty.appendChild(minus); qty.appendChild(qv); qty.appendChild(plus);
      mid.appendChild(t); mid.appendChild(m); mid.appendChild(qty);
      row.appendChild(mid);

      var right = document.createElement('div');
      right.className = 'wg-drawer__right';
      var price = document.createElement('b');
      price.textContent = euros(it.final_line_price);
      var rm = document.createElement('button'); rm.type = 'button'; rm.className = 'wg-drawer__rm'; rm.textContent = 'Retirer'; rm.setAttribute('aria-label', 'Retirer du panier');
      right.appendChild(price); right.appendChild(rm);
      row.appendChild(right);

      function change(q) {
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: it.key, quantity: q })
        }).then(function (r) { return r.json(); }).then(function (c2) {
          wgDrawerRender(c2);
          wgDrawerRefreshAll(c2);
        }).catch(function () {});
      }
      minus.addEventListener('click', function () { change(Math.max(0, it.quantity - 1)); });
      plus.addEventListener('click', function () { change(it.quantity + 1); });
      rm.addEventListener('click', function () { change(0); });

      linesBox.appendChild(row);
    });

    if (cart.item_count === 0) {
      var empty = document.createElement('p');
      empty.className = 'wg-drawer__empty';
      empty.textContent = 'Votre panier est vide — vos armées attendent leur terrain.';
      linesBox.appendChild(empty);
    }

    /* Jauge livraison du drawer */
    var gtext = wgDrawer.querySelector('[data-wg-drawer-gauge-text]');
    var gfill = wgDrawer.querySelector('[data-wg-drawer-gauge-fill]');
    var badge = document.querySelector('[data-wg-cart-count]');
    var threshold = parseInt((badge && badge.dataset.freeShipping) || '8000', 10);
    if (gtext && gfill) {
      if (cart.total_price >= threshold) {
        gtext.innerHTML = '<b>Livraison offerte</b> — seuil atteint';
        gfill.style.width = '100%';
      } else {
        gtext.innerHTML = 'Plus que <b>' + euros(threshold - cart.total_price) + '</b> pour la livraison offerte';
        gfill.style.width = Math.min(100, Math.round(cart.total_price * 100 / threshold)) + '%';
      }
    }
  }

  function wgOpenDrawer(cart) {
    if (!wgDrawer) return false;
    wgDrawerRender(cart);
    wgDrawer.classList.add('is-open');
    wgDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    return true;
  }
  function wgCloseDrawer() {
    if (!wgDrawer) return;
    wgDrawer.classList.remove('is-open');
    wgDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  if (wgDrawer) {
    wgDrawer.querySelectorAll('[data-wg-drawer-close]').forEach(function (b) {
      b.addEventListener('click', wgCloseDrawer);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') wgCloseDrawer(); });
  }
});
